import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Tooltip, Text } from 'pcln-design-system'
import PriceRangeBox from './PriceRangeBox'

const formatPrice = (price) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(price)
}

const PriceGuidanceChart = ({ highPrice, lowPrice, actualPrice }) => (
  <React.Fragment>
    <Box mt={'60px'} width={actualPrice < lowPrice ? '25%' : '100%'}>
      <Tooltip bg='primary.base' color='text.lightest' top center>
        <Text fontSize={0}>{formatPrice(actualPrice)}</Text>
      </Tooltip>
    </Box>
    <Flex>
      <Box height='5px' borderRadius='xl' m={'1px'} width={1 / 4} bg='success.base' />
      <Box height='5px' borderRadius='xl' m={'1px'} width={1 / 2} bg='caution.base' />
      <Box height='5px' borderRadius='xl' m={'1px'} width={1 / 4} bg='warning.base' />
    </Flex>
    <Flex mt={1} mb={'16px'} ml='25%' width={1 / 2}>
      <PriceRangeBox price={formatPrice(lowPrice)} />
      <PriceRangeBox price={formatPrice(highPrice)} align={'right'} />
    </Flex>
  </React.Fragment>
)

PriceGuidanceChart.propTypes = {
  highPrice: PropTypes.string.isRequired,
  lowPrice: PropTypes.string.isRequired,
  actualPrice: PropTypes.string.isRequired,
}

export default PriceGuidanceChart
